var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-scroll-container": "" } }, [
    _c("div", { attrs: { "data-scroll-section": "" } }, [
      _c(
        "div",
        { staticClass: "row justify-content-center align-items-center h-100" },
        [
          _c("div", { staticClass: "col-xxl-10 col-xl-12 col-lg-13 col-15" }, [
            _c("h1", { staticClass: "title" }, [_vm._v("client area")]),
            _vm._v(" "),
            _c("p", { staticClass: "xxsmall font-weight-light mt-2" }, [
              _vm._v(
                "\n          Please use credentials has been sent via email to enter\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "mt-5",
                attrs: { action: "", method: "POST" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit()
                  },
                },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-wrapper label-float",
                        class: {
                          "has-error":
                            _vm.$v.loginForm.email.$error ||
                            _vm.loginForm.error,
                          "has-value": _vm.$v.loginForm.email.$model,
                        },
                      },
                      [
                        _vm.$v.loginForm.email.$error &&
                        !_vm.$v.loginForm.email.required
                          ? _c("p", { staticClass: "error-msg" }, [
                              _vm._v(
                                "\n                  PLEASE FILL THIS\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.loginForm.email.$error &&
                        !_vm.$v.loginForm.email.email
                          ? _c("p", { staticClass: "error-msg" }, [
                              _vm._v(
                                "\n                  FILL AN EMAIL\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v("email"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.loginForm.email.$model,
                              expression: "$v.loginForm.email.$model",
                            },
                          ],
                          attrs: { id: "email", type: "text" },
                          domProps: { value: _vm.$v.loginForm.email.$model },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.loginForm.email,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-wrapper label-float",
                        class: {
                          "has-error": _vm.$v.loginForm.password.$error,
                          "has-value": _vm.$v.loginForm.password.$model,
                        },
                      },
                      [
                        _vm.$v.loginForm.password.$error &&
                        !_vm.$v.loginForm.password.required
                          ? _c("p", { staticClass: "error-msg" }, [
                              _vm._v(
                                "\n                  PLEASE FILL THIS\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "password" } }, [
                          _vm._v("password"),
                        ]),
                        _vm._v(" "),
                        _c("input-password", {
                          attrs: { id: "password" },
                          on: {
                            input: function ($event) {
                              _vm.loginForm.password = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-5" }, [
                  _vm.loginForm.sending
                    ? _c("div", { staticClass: "col-16" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-16 text-right position-relative" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-submit",
                          class: [
                            _vm.loginForm.response.status,
                            { loading: _vm.loginForm.sending },
                          ],
                          attrs: {
                            disabled: _vm.loginForm.response.status,
                            type: "submit",
                          },
                        },
                        [
                          _c("span", { staticClass: "background" }),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _c("span", { staticClass: "loader" }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.loginForm.response.message
                        ? _c("p", { staticClass: "btn-response" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.loginForm.response.message) +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-arrow-tail-right" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }